import script from "./TopUsersChart.vue?vue&type=script&setup=true&lang=js"
export * from "./TopUsersChart.vue?vue&type=script&setup=true&lang=js"

import "./TopUsersChart.vue?vue&type=style&index=0&id=e97446ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e97446ee"]])

export default __exports__